import { ImagePlusTextProps } from '@design-system/image-plus-text';

import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { imageMapper } from '~/mappers/image/imageMapper';
import { pageBlockMapper } from '~/mappers/pageBlock';

import { ImagePlusTextBlock } from './models';

export const imagePlusTextBlockMapper = ({
  image,
  content,
  pageBlock,
  componentId,
  ctaBlocks,
  imagePosition,
  imageWidth,
  align,
}: ImagePlusTextBlock): ImagePlusTextProps =>
  ({
    ...(pageBlock && { pageBlock: pageBlockMapper(pageBlock) }),
    image: image?.image && imageMapper(image),
    ...(content && { content }),
    ...(ctaBlocks?.ctaBlocks.length && {
      ctaBlock: ctaBlockMapper(ctaBlocks.ctaBlocks),
    }),
    id: componentId,
    imagePosition,
    imageWidth,
    align,
  } as ImagePlusTextProps);
